<div class="w-100 bg-white pt-1">

  <app-page-content-header
    (closeButtonClick)="closeBottomSheet()"
    [showCloseButton]="true"
    [title1]="data?.header ? data.header : 'shared.additionalInformation'">
  </app-page-content-header>

  <!--  content-->
  @if (data.type === 'symptomInfo') {
    <ng-container [ngTemplateOutlet]="symptomInfo"></ng-container>
  }
  @if (data.type === 'moreInfo') {
    <ng-container [ngTemplateOutlet]="moreInfo"></ng-container>
  }
  @if (data.type === 'myDiseases') {
    <ng-container [ngTemplateOutlet]="myDiseases"></ng-container>
  }
  @if (data.type === 'certModal') {
    <ng-container [ngTemplateOutlet]="certModal"></ng-container>
  }
  @if (data.type === 'terminateLeave') {
    <ng-container [ngTemplateOutlet]="terminateLeave"></ng-container>
  }
  @if (data.type === 'appointment') {
    <ng-container [ngTemplateOutlet]="appointment"></ng-container>
  }
  @if (data.type === 'consentModal') {
    <ng-container [ngTemplateOutlet]="consentModal"></ng-container>
  }
  @if (data.type === 'eekInfoModal') {
    <ng-container [ngTemplateOutlet]="eekInfoModal"></ng-container>
  }
  @if (data.type === 'eekInfoResultsModal') {
    <ng-container [ngTemplateOutlet]="eekInfoResultsModal"></ng-container>
  }
  @if (data.type === 'prescriptionIssuedMoreInfo') {
    <ng-container [ngTemplateOutlet]="prescriptionIssuedMoreInfo"></ng-container>
  }
</div>


<ng-template #symptomInfo>
  <div class="d-flex flex-column gap-05 p-4">
    @for (symptomInfo of data.symptoms | keyvalue; track symptomInfo) {
      @if (symptomInfo.value && symptomInfo.key !== 'other') {
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div class="fw-bold font-1 line-height-25">{{ "symptomInfo.header." + symptomInfo.key | translate }}</div>
            </mat-expansion-panel-header>
            @if (symptomInfo.value) {
              <div [innerHtml]="'symptomInfo.' + symptomInfo.key | translate"
              class="symptom-info pt-2"></div>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
    }
  </div>
</ng-template>

<ng-template #moreInfo>
  <div class="d-flex justify-content-center flex-column font-1">
    <div class="pt-4 row">
      <div class="col"> <span class="fw-bold">
        {{ 'questions.subject' | translate }}&nbsp;
      </span>
      <span>
        {{ 'questions.subjectInfo' | translate }}
      </span></div>
    </div>
    <div class="pt-4 row">
      <div class="col"> <span class="fw-bold">
        {{ 'questions.message' | translate }}&nbsp;
      </span>
      <span>
        {{ 'questions.messageInfo' | translate }}
      </span></div>
    </div>
  </div>
</ng-template>

<ng-template #myDiseases>
  <div class="container-flex justify-content-center font-1 pt-4">
    <div class="row">{{ 'settings.myDiseasesDescription' | translate }}</div>
  </div>
</ng-template>

<ng-template #certModal>
  <div class="d-flex justify-content-center flex-column pt-3 font-1">
    <div>
      {{ "certificate.certInfo1" | translate }}
      <a class="link-color"
        href="https://www.terviseportaal.ee"
        target="_blank">terviseportaal.ee<span class="sr-only"> ({{ 'accessibility.opensInNewTab' | translate }}
      )</span>
    </a>.
  </div>
  <br />
  <div>
    <b>{{ "certificate.certOption2" | translate }}</b>
    {{ "certificate.certInfo2" | translate }}
  </div>
</div>
</ng-template>

<ng-template #terminateLeave>
  <div class="d-flex justify-content-center align-items-center flex-column pt-3 font-1">
    <div class="pt-2">
      <span class="fw-bold space">{{ "terminateLeave.schedule" | translate }}</span>
      <span>{{ "terminateLeave.scheduleInfo1" | translate }}</span>
    </div>
    <div class="pt-2">{{ "terminateLeave.scheduleInfo2" | translate }}</div>
  </div>
</ng-template>

<ng-template #appointment>
  <div class="d-flex flex-column pt-3 font-1">
    <div class="pt-2">
      <span
      class="fw-bold space">{{ 'appointment.' + (data.whomVisit === 'doctor' ? 'chooseAnyDoctor' : 'chooseAnyNurse') | translate }}</span>
      <span>{{ 'appointment.anyPerson' | translate }}</span>
    </div>
    <div class="pt-2">
      <span
      class="fw-bold space">{{ 'appointment.' + (data.whomVisit === 'doctor' ? 'chooseSpecificDoctor' : 'chooseSpecificNurse') | translate }}</span>
      <span>{{ 'appointment.specificPerson' | translate }}</span>
    </div>
  </div>
</ng-template>

<ng-template #consentModal>
  <div class="d-flex flex-column gap-05 p-4">
    @for (symptomInfo of data.symptoms | keyvalue; track symptomInfo) {
      @if (symptomInfo.value && symptomInfo.key !== 'other') {
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div class="fw-bold font-1 line-height-25">{{ "symptomInfo.header." + symptomInfo.key | translate }}</div>
            </mat-expansion-panel-header>
            @if (symptomInfo.value) {
              <div [innerHtml]="'symptomInfo.' + symptomInfo.key | translate"
              class="symptom-info pt-2"></div>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
    }
  </div>
</ng-template>

<ng-template #eekInfoModal>
  <p class="text-left-margin">{{ "moodForm.moreInfo1" | translate }}</p>
  <p class="text-left-margin">{{ "moodForm.moreInfo2" | translate }}
    <span class="fw-bold">{{ "moodForm.moreInfo3" | translate }}</span>
  </p>
</ng-template>

<ng-template #eekInfoResultsModal>
  <div class="font-1">
    <div>{{ "moodForm.resultsInfo1" | translate }}</div>
    <br>
      <div class=bold-left>{{ "moodForm.deprLimit" | translate }}</div>
      <div class=bold-left>{{ "moodForm.anxLimit" | translate }}</div>
      <div class=bold-left>{{ "moodForm.panicLimit" | translate }}</div>
      <div class=bold-left>{{ "moodForm.socialLimit" | translate }}</div>
      <div class=bold-left>{{ "moodForm.exhaustionLimit" | translate }}</div>
      <div class=bold-left>{{ "moodForm.sleepLimit" | translate }}</div>
      <br>
        <div>{{ "moodForm.resultsInfo2" | translate }}</div>
      </div>
    </ng-template>

    <ng-template #prescriptionIssuedMoreInfo>
      <div class="font-1">
        <div>{{ "shared.additionalInformation" | translate }}</div>
      </div>
    </ng-template>

